export function abbreviateSpaceName(label: string): string {
  const words = label.split(/[\s-]+/).filter((word) => word.length > 0);
  const initials = words
    .map((word) => {
      const stripped = word.replace(/^[^A-Za-z0-9]+|[^A-Za-z0-9]+$/g, '');
      return stripped.charAt(0);
    })
    .join('')
    .toUpperCase();

  return initials || label;
}
